import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid, Toolbar } from '@mui/material';
import { TextField, IconButton, Autocomplete } from '@totalsoft/rocket-ui';
import { ToolbarWrapper } from '../VerificationStyles';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';

const DocumentVerificationToolbar = ({
  t,
  fullTextFilter,
  onFilterValueChanged,
  onResetFilters,
  onVerificationSorterChanged,
  verificationSorterOptions,
  selectedVerificationOrder
}) => {
  return (
    <ToolbarWrapper>
      <Toolbar>
        <Grid item xs={6} pt={2}>
          <TextField
            id={'documentVerificationList_filters_fullText'}
            fullWidth={true}
            name='fullTextFilter'
            value={fullTextFilter}
            onChange={e => onFilterValueChanged(e, true)}
            placeholder={t('Placeholders.VerificationSearch')}
            startAdornment={<Search />}
            endAdornment={
              <IconButton
                onClick={onResetFilters}
                id={'documentVerificationList_filters_resetBtn'}
                color='transparent'
                tooltip={t('Tooltips.ResetFilters')}
                size={'tiny'}
              >
                <Close />
              </IconButton>
            }
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={2}>
          <Autocomplete
            id={'verificationSorter'}
            label={t('General.OrderBy')}
            fullWidth
            value={selectedVerificationOrder}
            onChange={onVerificationSorterChanged}
            labelKey='name'
            valueKey='id'
            options={verificationSorterOptions}
            isClearable={false}
            isSearchable={false}
          />
        </Grid>
      </Toolbar>
    </ToolbarWrapper>
  );
};

DocumentVerificationToolbar.propTypes = {
  t: PropTypes.func.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  onFilterValueChanged: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  onVerificationSorterChanged: PropTypes.func.isRequired,
  verificationSorterOptions: PropTypes.array.isRequired,
  selectedVerificationOrder: PropTypes.object.isRequired
};

export default compose(withTranslation())(DocumentVerificationToolbar);
